import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "monitorList",
    component: () => import("../views/MonitorList.vue"),
  },
  {
    path: "/monitor/index",
    name: "home",
    component: () => import("../views/ProductPage.vue"),
  },
  {
    path: "/monitor/list",
    name: "monitorList",
    component: () => import("../views/MonitorList.vue"),
  },
  {
    path: "/tv/list",
    name: "tvList",
    component: () => import("../views/MonitorList.vue"),
  },
  {
    path: "/product/contact",
    name: "productContact",
    component: () => import("../views/ProductContact.vue"),
  },
  {
    path: "/monitor/:brand/:model",
    name: "monitor",
    component: () => import("../views/detail.vue"),
  },
  {
    path: "/tv/:brand/:model",
    name: "tvDetail",
    component: () => import("../views/TvDetail.vue"),
  },
  {
    path: "/compare",
    name: "compare",
    component: () => import("../views/compare.vue"),
  },
  {
    path: "/compare/tv",
    name: "compareTv",
    component: () => import("../views/compare-tv.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});
const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.push = function (location) {
  return originalReplace.call(this, location).catch((error) => error);
};
export default router;
